import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { messageSelect, messageNewMessage, messageReadAll, messageRead } from '@/utils/api/common';

const initialState = {
  list: [],
  total: 0,
  loading: false,
  unreadCount: 0,
  newMessageList: [],
  summaryDone: false,
  newMessageDone: false,
  noticeCenterOpen: false,
  isFreshLogin: false,
};

export const asyncNoticeInit = createAsyncThunk(
  "notice/asyncNoticeInit",
  async (params = {}) => {
    const { data: { data = {}, code } } = await messageSelect(params);
    if (+code === 0) {
      return data;
    }
    return { list: [], total: 0 };
  }
);

export const asyncNewMessage = createAsyncThunk(
  "notice/asyncNewMessage",
  async (params = {}, { dispatch }) => {
    const { data: { data = {}, code } } = await messageNewMessage(params);
    if (+code === 0) {
      const { list = [] } = data;
      if (list.length > 0) {
        dispatch(asyncNoticeInit());
      }
      return data;
    }
    return { list: [], total: 0 };
  }
);

export const asyncMessageReadAll = createAsyncThunk(
  "notice/asyncMessageReadAll",
  async () => {
    const { data: { code } } = await messageReadAll();
    return { code };
  }
);

export const asyncMessageRead = createAsyncThunk(
  "notice/asyncMessageRead",
  async (params = {}) => {
    const { data: { code } } = await messageRead(params);
    return { code, id: params.id };
  }
);

export const slice = createSlice({
  name: "notice",
  initialState,
  reducers: {
    setNoticeCenterOpen: (state, action) => {
      state.noticeCenterOpen = action.payload;
      if (action.payload) {
        state.newMessageList = state.newMessageList.filter(item => item.id !== 'notice-summary');
      }
    },
    setIsFreshLogin: (state, action) => {
      console.log('[notice] setIsFreshLogin:', action.payload);
      state.isFreshLogin = action.payload;
    },
    removeNewMessage: (state, action) => {
      state.newMessageList = state.newMessageList.filter(item => item.id !== action.payload);
    },
    resetNoticeState: (state) => {
      Object.assign(state, initialState, { isFreshLogin: true });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncNoticeInit.pending, (state) => {
        state.loading = true;
      })
      .addCase(asyncNewMessage.pending, (state) => {
        state.newMessageDone = false;
      })
      .addCase(asyncNoticeInit.fulfilled, (state, action) => {
        const { list = [], total = 0, unread } = action.payload;
        const currentPage = action.meta.arg?.page || 1;

        if (currentPage === 1) {
          state.list = list;
        } else {
          state.list = [...state.list, ...list];
        }
        state.summaryDone = true;
        state.total = total;
        state.unreadCount = unread;
        state.loading = false;
      })
      .addCase(asyncNoticeInit.rejected, (state) => {
        state.loading = false;
      })
      .addCase(asyncNewMessage.fulfilled, (state, action) => {
        const { list = [] } = action.payload;
        const existingIds = new Set(state.newMessageList.map(item => item.id));
        const newItems = list.filter(item => !existingIds.has(item.id));
        state.newMessageList = [...state.newMessageList, ...newItems];
        // console.log(state.newMessageList, state.isFreshLogin, state.unreadCount);
        if (state.isFreshLogin && state.unreadCount > 0) {
          if (!state.newMessageList.some(item => item.id === 'notice-summary')) {
            state.newMessageList = [
              ...state.newMessageList,
              { id: 'notice-summary', title: '未读消息提醒', content: `您有 <span style="color:red">${state.unreadCount}</span> 条消息通知未读，请及时查看` }
            ];
            state.isFreshLogin = false;
          }
        }
        const seen = new Set();
        state.newMessageList = state.newMessageList.filter(item => {
          if (seen.has(item.id)) return false;
          seen.add(item.id);
          return true;
        });
        state.newMessageDone = true;
      })
      .addCase(asyncNewMessage.rejected, (state) => {
        state.newMessageDone = true;
      })
      .addCase(asyncMessageReadAll.fulfilled, (state) => {
        state.list = state.list.map(item => ({ ...item, is_read: 1 }));
        state.unreadCount = 0;
      })
      .addCase(asyncMessageRead.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.list = state.list.map(item => item.id === id ? { ...item, is_read: 1 } : item);
        if (state.unreadCount > 0) {
          state.unreadCount = state.unreadCount - 1;
        }
      });
  },
});

const { reducer, actions } = slice;
export const { setNoticeCenterOpen, setIsFreshLogin, removeNewMessage, resetNoticeState } = actions;
export default reducer;